import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ChartType, ChartOptions } from 'chart.js';
import { Color, Label, SingleDataSet } from 'ng2-charts';
import { WidgetModel, WidgetInfoModel, InformationModel } from '../../../../core/models/widget.model';
import { HomeService } from 'src/app/home/service/home.service';
import { Router } from '@angular/router';
import {GoogleTagManagerService} from "../../../../core/analytics/google-tag-manager.service";

@Component({
  selector: 'app-facs-time',
  templateUrl: './facs-time.component.html',
  styleUrls: ['./facs-time.component.scss']
})
export class FacsTimeComponent implements OnInit, OnDestroy {

  private rawInfo: InformationModel[];
  @Input() set info(widgetInfo: InformationModel[]) {
    this.rawInfo = widgetInfo;
    this.sortValuesAndProcess();
  }

  @Input() public dragged: boolean;
  @Input() public data: WidgetModel;
  @Input() public scrolling: boolean;

  public timer: any;
  public chartData: boolean;
  pIdx: number[] = [0, 1, 2];

  public doughnutChartLabelA: Label[] = ['A', 'B'];
  public doughnutChartLabelB: Label[] = ['A', 'B'];
  public doughnutChartLabelC: Label[] = ['A', 'B'];

  public doughnutChartDataA: SingleDataSet = [0, 1];
  public doughnutChartDataB: SingleDataSet = [0, 1];
  public doughnutChartDataC: SingleDataSet = [0, 1];

  public doughnutChartColorA: Color[] = [{ borderColor: ['#75e29e', '#ccfaf0'], backgroundColor: ['#75e29e', '#ccfaf0'] }];
  public doughnutChartColorB: Color[] = [{ borderColor: ['#fdd626', '#fff9cc'], backgroundColor: ['#fdd626', '#fff9cc'] }];
  public doughnutChartColorC: Color[] = [{ borderColor: ['#ea4e2f', '#f6cbcc'], backgroundColor: ['#ea4e2f', '#f6cbcc'] }];

  public doughnutChartOptions: ChartOptions = {
    cutoutPercentage: 80,
    animation: { duration: 0 },
    legend: { display: false },
    tooltips: { enabled: false },
    elements: {
      arc: { borderWidth: 0 },
    }
  };

  public doughnutChartType: ChartType = 'doughnut';

  constructor(private homeSvc: HomeService,
              private router: Router,
              private readonly googleTagManagerService: GoogleTagManagerService) { }

  ngOnInit() {
    this.homeSvc.fetchWidgetData(this.data.id);
    this.timer = window.setInterval(() => {
      this.homeSvc.fetchWidgetData(this.data.id);
    }, this.data.update_timer);
  }

  ngOnDestroy() {
    window.clearInterval(this.timer);
  }

  headerAction() {
    if (this.scrolling) {
      return;
    }

    this.googleTagManagerService.pushTag({
      event: 'event',
      eventCategory: 'crm:home',
      eventAction: 'clique:widgets:minhas-facs'
    });

    this.router.navigate([`${this.data.action.url}`]);
  }

  iconAction(idx: number) {
    if (this.scrolling) {
      return;
    }

    const dueDateLabel = this.rawInfo[idx].action.url;

    this.googleTagManagerService.pushTag({
      event: 'event',
      eventCategory: 'crm:home',
      eventAction: 'clique:widgets:minhas-facs',
      eventLabel: dueDateLabel.toLowerCase()
    });

    this.router.navigate([`/facs`], { queryParams: { vencimentos: `${dueDateLabel}` }});
  }

  sortValuesAndProcess() {
    if (!this.rawInfo || this.rawInfo.length < 3) {
      return false;
    } else {
      let valuesTotal = this.rawInfo[0].values.total + this.rawInfo[1].values.total + this.rawInfo[2].values.total;
      if (valuesTotal === 0) {
        valuesTotal = 1;
      }
      this.doughnutChartDataA = [ this.rawInfo[0].values.total, valuesTotal - this.rawInfo[0].values.total];
      this.doughnutChartDataB = [ this.rawInfo[1].values.total, valuesTotal - this.rawInfo[1].values.total];
      this.doughnutChartDataC = [ this.rawInfo[2].values.total, valuesTotal - this.rawInfo[2].values.total];
      this.chartData = true;
    }
  }
}
